var $6e4cedf50ab689ea$exports = {};
$6e4cedf50ab689ea$exports = {
    "loading": `Y\xfckleniyor...`,
    "loadingMore": `Daha fazla y\xfckleniyor...`
};


export {$6e4cedf50ab689ea$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
